import { Link } from 'react-router-dom'
import '../styles/unauthorized.css'

const UnAuthorized = () => {
  return (
    <div className='component_wrapper unauthorized'>
      <h2 className='sub_title'> Un-Authorized! </h2>
      <h3 className="">Please login to continue.</h3>
      
      <br/><br/><br/>
      
      <Link to='/signin'> 
        <button className='btn_unauthorized btn_primary'> Login</button>
      </Link>
    </div>
  )
}

export default UnAuthorized;